import { API_URL } from "../constants";

export const GET_NAVBAR = `${API_URL}v2/module-component/public/avantthya/nav-bar`;
export const GET_FOOTER = `${API_URL}v2/module-component/public/avantthya/footer`;
export const GET_MAIN_PAGE = `${API_URL}v2/module-component/public/avantthya/main-page`;

export const GET_PRODUCT_TYPE = (productType: string) => `${API_URL}v2/module-component/public/avantthya/product-type/${productType}`;
export const GET_PATHS_PRODUCT_TYPES = `${API_URL}producttype/public/avantthya/path-product-types/`;

export const GET_PRODUCT = (product: string) => `${API_URL}v2/module-component/public/avantthya/product/${product}`;
export const GET_PATHS_PRODUCTS = `${API_URL}product/public/avantthya/path-products/`;